import { housekeepingQueryKeys as e } from "./useHousekeepingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspacesApi as r } from "@maat/api-main";
//#region src/housekeeping/useUpdateWorkspaceOperationsSettingsMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.updateOperationsSettings(e),
		onSuccess: (t) => {
			i.setQueryData(e.settings(), t), i.invalidateQueries({ queryKey: e.board() }), i.invalidateQueries({ queryKey: e.attention() });
		}
	});
};
//#endregion
export { i as useUpdateWorkspaceOperationsSettingsMutation };
